import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var modalPrefix = 'preview-modal';
var navigationButtonSuffix = "navigation-button-tooltip";
export var modalPreviewIDs = {
  overlay: "".concat(modalPrefix, "-overlay"),
  innerOverlay: "".concat(modalPrefix, "-inner-overlay")
};
export var arrowsDirection = {
  rightArrow: 'right-arrow',
  leftArrow: 'left-arrow'
};
export var dataHooks = _objectSpread({
  modalPreviewActions: "".concat(modalPrefix, "-actions"),
  modalPreviewCloseButton: "".concat(modalPrefix, "-close-button"),
  modalPreviewTitle: "".concat(modalPrefix, "-title"),
  modalPreviewContent: "".concat(modalPrefix, "-content"),
  modalPreviewRightArrow: "".concat(modalPrefix, "-").concat(arrowsDirection.rightArrow),
  modalPreviewLeftArrow: "".concat(modalPrefix, "-").concat(arrowsDirection.leftArrow),
  nextNavigationButtonTooltip: "next-".concat(navigationButtonSuffix),
  prevNavigationButtonTooltip: "prev-".concat(navigationButtonSuffix),
  closeButtonTooltip: "close-button-tooltip"
}, modalPreviewIDs);